import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const HowtoPrepareforanHMRCAudit = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "How to Prepare for an HMRC Audit?";

  const title = "How to Prepare for an HMRC Audit?";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>How to Prepare for an HMRC Audit? | MSB</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="How to Prepare for an HMRC Audit? | MSB"
        />
        <meta property="og:description" content="" />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
             <h1 className="page_title text-white">
             How to Prepare for an HMRC Audit?
            </h1>
           {/* <motion.h1
                         className="page_title text-white"
                         initial="hidden"
                         animate="visible"
                         style={{
                           display: "flex",
                           justifyContent: "center",
                           flexWrap: "wrap", // wrap text across lines
                           textAlign: "center",
                         }}
                       >
                         {title.split(/(\/n)/).map((segment, i) => {
                           if (segment === "/n") {
                             return <br key={`br-${i}`} />;
                           }
           
                           return segment.split("").map((letter, index) => (
                             <motion.span
                               key={`${i}-${index}`}
                               custom={index}
                               variants={letterVariants}
                               style={{
                                 display: "inline-block",
                                 marginRight: letter === " " ? "0.3rem" : "0",
                                 whiteSpace: "pre",
                               }}
                             >
                               {letter}
                             </motion.span>
                           ));
                         })}
                       </motion.h1> */}
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/how-to-series">How to Series?</NavLink>
              </li>
              <li className="active">
                <a href="#!">How to Prepare for an HMRC Audit?</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              {/* <h2 className="item_details_heading">
                {headingText.split("").map((char, i) => (
                  <motion.span
                    key={`${char}-${i}`}
                    custom={i}
                    initial="hidden"
                    animate="visible"
                    variants={headingVariants}
                  >
                    {char}
                  </motion.span>
                ))}
              </h2> */}
              <div className="d-flex justify-content-end mb-3">
                <NavLink
                  to="/how-to-series"
                  className="btn bg-primary text-dark"
                >
                  &larr; Back
                </NavLink>
              </div>
              <img
                className="rounded-2"
                src="assets/images/how-to-series/how-to-prepare-for-an-hmrc-audit.png"
                alt="How to Prepare for an HMRC Audit?"
              />
              <p className="mt-4 mb-2">
                HMRC may carry out a compliance check—either through a visit or
                an office-based review. The goal is to ensure you are complying
                with your legal responsibilities, including having appropriate
                AML controls and documentation in place.
              </p>
              <p className="mb-2">During an audit, HMRC may:</p>
              <ul className="mt-0 mb-2">
                <li>
                  Ask more than 150 questions to test your compliance knowledge,
                  covering areas such as your AML risk assessment, customer due
                  diligence (CDD), policies and procedures, and staff
                  understanding.
                </li>
                <li>Inspect physical cash on-site.</li>
                <li>
                  Spend approximately 3 to 4 hours on-site, depending on the
                  complexity of your business.
                </li>
              </ul>
              <p className="mt-0">
                This guide explains what to expect and how to prepare, so you
                can stay compliant and confident.
              </p>

              <h4>&#10148; Why HMRC May Visit You</h4>
              <p className="mb-2">HMRC may check your business if:</p>
              <ul className="mt-0 mb-2">
                <li>There's a perceived risk of money laundering exposure</li>
                <li>
                  You're selected for a routine or random compliance check
                </li>
              </ul>
              <p className="mt-2">
                This doesn’t necessarily mean something is wrong—but it’s
                important to be ready.
              </p>

              <h4>&#10148; What HMRC Will Check</h4>
              <p className="mb-2">HMRC officers will focus on:</p>
              <ul className="mt-0 mb-4">
                <li>Your anti-money laundering (AML) risk assessment</li>
                <li>Your policies, controls, and procedures</li>
                <li>
                  How these are understood, implemented, and maintained across
                  your business
                </li>
                <li>
                  Your systems for identifying and reporting suspicious activity
                </li>
                <li>Staff training and awareness of AML responsibilities</li>
              </ul>

              <h4>&#10148; Types of Checks</h4>
              <h5 className="mt-4">1. Office-Based Check</h5>
              <ul className="mt-0">
                <li>Conducted via phone, email, or desk-based review</li>
                <li>Involves submission of documents and records remotely</li>
                <li>May be followed up with further checks if needed</li>
              </ul>

              <h5 className="mt-4">2. On-site Visit</h5>
              <ul className="mt-0 mb-4">
                <li>
                  Usually arranged in advance by phone and confirmed in writing
                </li>
                <li>May be unannounced in rare cases</li>
                <li>Takes place at your main business premises</li>
                <li>
                  Officers will want access to documents, records, staff, and
                  systems
                </li>
              </ul>

              <h4>&#10148; Who Should Be Present</h4>
              <p className="mb-2">During the check, HMRC may speak with:</p>
              <ul className="mt-0 mb-4">
                <li>The business owner or UBO’s</li>
                <li>A senior manager or MLRO</li>
                <li>Other staff members involved in compliance</li>
              </ul>

              <h4>
                &#10148; Documents and Records to Prepare for HMRC Compliance
                Checks
              </h4>
              <p className="mb-2">
                To ensure a smooth HMRC audit and minimise the risk of
                penalties, businesses should have the following documentation
                and systems in place:
              </p>
              <ul className="mt-0 mb-4">
                <li>
                  <h6>AML Risk Assessment</h6>
                  <p>
                    An updated risk assessment tailored to your business
                    activities.
                  </p>
                </li>
                <li>
                  <h6>AML Policies and Procedures</h6>
                  <p>
                    Documented policies covering CDD, EDD, record keeping, SARs,
                    and staff training which should align with amended
                    regulations.
                  </p>
                </li>
                <li>
                  <h6>
                    Customer Due Diligence (CDD) and Enhanced Due Diligence
                    (EDD)
                  </h6>
                  <p>
                    Comprehensive records of customer due diligence and enhanced
                    due diligence.
                  </p>
                </li>
                <li>
                  <h6>Ongoing Monitoring Evidence</h6>
                  <p>
                    Documentation showing a risk-based approach and evidence of
                    ongoing monitoring.
                  </p>
                </li>
                <li>
                  <h6>Staff Training Records</h6>
                  <p>
                    Logs demonstrating AML understanding for all relevant staff
                  </p>
                </li>
                <li>
                  <h6>Business and Transaction Records</h6>
                  <p>
                    Including remittance logs and cash reconciliation (if
                    applicable).
                  </p>
                </li>
                <li>
                  <h6>Internal Audit Reports</h6>
                  <p>Reports on AML compliance and internal audits.</p>
                </li>
                <li>
                  <h6>Fit and Proper Tests</h6>
                  <p>Records of fit and proper tests and HMRC approvals.</p>
                </li>
                <li>
                  <h6>Suspicious Activity Reports (SARs)</h6>
                  <p>Copies of SARs submitted to the NCA and internal SARs.</p>
                </li>
                <li>
                  <h6>Personal Documentation</h6>
                  <p>
                    Identity verification documents, and staff training logs for
                    the responsible person or MLRO.
                  </p>
                </li>
              </ul>

              <h4>&#10148; Tips for Staying Ready</h4>
              <ul className="mt-0 mb-4">
                <li>
                  Subscribe for a software which can manage compliance and day
                  to day activities easily.
                </li>
                <li>Regularly review and update your AML policies.</li>
                <li>Keep records tidy, clear, and accessible.</li>
                <li>Train all staff and document that training.</li>
                <li>Conduct internal audits and act on findings.</li>
                <li>Appoint a dedicated AML compliance officer.</li>
              </ul>

              <div
                className="container p-5"
                style={{ background: "#fff", borderRadius: "10px" }}
              >
                <div className="row align-items-center">
                  <div className="col-lg-12">
                    <h2 className="heading_text">Need Help?</h2>
                    <p>
                      Consider engaging a compliance consultant or legal adviser if you need support setting up or reviewing your AML framework.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HowtoPrepareforanHMRCAudit;
